<template>
    <div class="map-popup">
        <div class="popup-header">
            <div class="btn-x">
                <button class="btn-close" alt="closePopup" @click="close">X</button>
            </div>
        </div>
        <div class="popup-content">
                <l-map
                    :zoom="zoom"
                    ref="myMap"
                    :center="center"
                    @click="getWhat3Words"
                    >
                    <l-tile-layer
                        :url="url"
                        :attribution="attribution"
                    />
                </l-map>
            
        </div>
        <div class="popup-footer">


        </div>
    </div>
</template>

<script>

import axios from "axios";
import L from 'leaflet';
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
// import 'leaflet/dist/leaflet.css';

export default {
    name: "map-popup",
     data() {
        return {
            zoom:6,
            center: L.latLng(47.413220, -1.219482),
            url:'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
            attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            // zoom: 6,
            // center: [10.87, 100.9925],
            // url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
            // attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            // bounds: null
        };
    },
    components:{
        LMap,
        LTileLayer,
        LMarker,
    },
    methods:{
        close(){
            this.$emit(close);
        },
        zoomUpdate(zoom) {
            this.currentZoom = zoom;
        },
        centerUpdate(center) {
            this.currentCenter = center;
        },
        getWhat3Words(event) {
            const location = event.latlng;
            const url = `https://api.what3words.com/v3/convert-to-3wa?key=A2GMT0WL&coordinates=${location.lat},${location.lng}&language=en&format=json`;

            axios
                .get(
                url
                )
                .then(res => {
                    const data = res.data;
                    const word = data.words;
                    this.$emit('wordsdata',word);
                    this.close();
                })
                .catch(console.error);
        },
        // onMapLoaded() {
        //     const bounds = this.$refs.map.mapObject.getBounds();
        //     this.bounds = this.getBoundsData(bounds);
        // },
        // updateBounds(bounds) {
        //     this.bounds = this.getBoundsData(bounds);
        // },      
    }
        
    
}
</script>

<style lang="scss" scoped>
    .map-popup{
        position: relative;
        width: 50%;
        height: 600px;
        z-index: 10;
        margin-top: -60%;
        left: 30%;
        background-color: white;
        z-index: 1;
        .popup-header{
            background-color: rgb(207, 207, 207);
            height: 7%;
            .btn-close{
                position: absolute;
                top: 2%;
                right: 2%;
                font-size: 18px;
                color: white;
            }
        }
        .popup-content{
            // position: relative;
            width: 100%;
            height: 600px;
            .map{
                height: 100%;
                width: 100%;
            }
        }
    }
</style>